import {useCallback, useEffect, useState} from 'react';

const ANNOUNCEMENT_CLEAR_MS = 7000;

/**
 * The text for a polite live region, with the care a repeated message needs: a repeat must still
 * change the text or screen readers stay silent, and a spoken message clears after a few seconds
 * so a student browsing the question later doesn't land on it.
 */
export const useAnnouncer = (): {message: string; announce: (message: string) => void} => {
  const [message, setMessage] = useState('');

  const announce = useCallback((next: string) => {
    setMessage((last) => (last === next ? `${next}\u200B` : next));
  }, []);

  useEffect(() => {
    if (!message) return undefined;
    const timeout = setTimeout(() => setMessage(''), ANNOUNCEMENT_CLEAR_MS);
    return () => clearTimeout(timeout);
  }, [message]);

  return {message, announce};
};
